import React, { Component } from "react";
import areaService from "../../../api/Area/AreaService";
import { Row, Col, Button, Drawer, Empty } from "antd";
import "./style.scss";
export default class Area extends Component {
  constructor(props) {
    super(props);

    this.state = { areas: [], visible: false, placement: "top" };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllAreas();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  getAllAreas = () => {
    areaService
      .getAllAreas()
      .then((res) => {
        console.log("res", res);
        let areas = res.data;
        let branchId = localStorage.getItem("bId");
        areas = res.data.filter((area) => area.branchId === branchId);
        this.setState({ areas });
      })
      .catch((err) => {
        console.log(err);
        // toast.error(err.message, {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  render() {
    const { placement, visible, areas } = this.state;
    return (
      <Row gutter={24}>
        <Col span={24}>
          <Button
            className="top-red-rounded-button"
            onClick={this.showDrawer.bind(this)}
          >
            <span className="red-button-text">Area</span>
          </Button>
        </Col>
        <Drawer
          height={200}
          placement={placement}
          closable={true}
          onClose={this.onClose}
          visible={visible}
          key={placement}
        >
          <Row gutter={24} style={{ justifyContent: "center" }}>
            {areas?.length > 0 ? (
              areas.map((area) => {
                return (
                  <Col>
                    <Button
                      style={{ textDecoration: "none" }}
                      href="#"
                      className="topNav"
                    >
                      <span className="topNav-text">{area.name}</span>
                    </Button>
                  </Col>
                );
              })
            ) : (
              <Empty />
            )}
          </Row>
        </Drawer>
      </Row>
    );
  }
}
